import axios from "axios";

export default async function deleteUser(id) {
    try {
        const res = await axios.delete(
            `${process.env.REACT_APP_BACKEND_URL}/api/admin/user`,
            {
                data: { id },
                withCredentials: true,
                validateStatus: () => true,
            }
        );

        return {
            ok: res.status >= 200 && res.status < 300,
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        console.error("Erreur deleteUser:", err);
        return { ok: false, status: 0, error: err.message };
    }
}
